<script>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import 'vue-datepicker-next/locale/sv'

export default DatePicker
</script>

<style lang="scss">
.mx-datepicker {
  @apply w-full;
  @apply rounded;
}

.mx-input {
  @apply border-gray-300 dark:border-custom-purple-300;
  @apply px-4;
  @apply py-5;
  @apply text-sm;
  @apply text-black;
  @apply rounded;
}
.dark {
  .mx-input {
    @apply bg-custom-purple-500;
    @apply text-white;
    @apply placeholder-custom-purple-200;
  }

  .mx-icon-calendar {
    @apply text-custom-purple-200;
  }
}

.mx-calendar-content .cell.active {
  @apply bg-primary;
}
.mx-calendar-content .cell.in-range {
  @apply bg-primary;
}

.mx-datepicker-main.dark {
  @apply bg-custom-purple-400 border-custom-purple-600;

  .mx-calendar-content .cell.active {
    @apply bg-custom-purple-300;
  }
  .mx-calendar-content .cell.disabled {
    @apply bg-custom-purple-600;
    @apply text-gray-500;
  }
  .mx-btn {
    @apply text-custom-purple-200;
  }
}
</style>
